<div class="login-page">

  <!-- Panel izquierdo: marketing -->
  <div class="login-panel login-panel--left">

    <!-- Overlay tonal (efecto multiply como en Figma) -->
    <div class="panel-bg-overlay"></div>

    <div class="panel-content">

      <!-- Titular -->
      <h1 class="panel-headline">
        Tu equipo legal, siempre contigo
      </h1>
      <p class="panel-subheadline">
        Accede y disfruta de todas las ventajas de ser cliente de onLygal
      </p>
    </div>
  </div>

  <!-- Panel derecho: formulario -->
  <div class="login-panel login-panel--right">

    <!-- Logo -->
    <div class="login-logo">
      <img
        src="resources/assets/images/login/logo-login.png"
        alt="onLygal – Actuamos soluciones legales para vidas reales"
        class="login-logo__img"
      />
    </div>

    <!-- Formulario -->
    <div class="login-form-container">
      <h2 class="login-title">Accede a tu Área de Cliente</h2>

      <form class="login-form" [formGroup]="authenticationForm" (ngSubmit)="onSubmit()" novalidate>

        <!-- NIF/NIE -->
        <div class="form-field">
          <label class="form-label" for="nif">NIF/NIE</label>
          <input
            id="nif"
            type="text"
            class="form-input"
            formControlName="username"
            autocomplete="username"
          />
        </div>

        <!-- Contraseña -->
        <div class="form-field">
          <label class="form-label" for="password">Contraseña</label>
          <div class="form-input-wrapper">
            <input
              id="password"
              [type]="showPassword ? 'text' : 'password'"
              class="form-input form-input--password"
              formControlName="password"
              autocomplete="current-password"
            />
            <button
              type="button"
              class="toggle-password"
              (click)="togglePassword()"
              [attr.aria-label]="showPassword ? 'Ocultar contraseña' : 'Mostrar contraseña'"
            >
              <svg *ngIf="!showPassword" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                <path d="M10 4C5.5 4 2 10 2 10C2 10 5.5 16 10 16C14.5 16 18 10 18 10C18 10 14.5 4 10 4Z" stroke="#A2AAAD" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <circle cx="10" cy="10" r="2.5" stroke="#A2AAAD" stroke-width="1.5"/>
              </svg>
              <svg *ngIf="showPassword" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                <path d="M3 3L17 17M8.27 8.27A2.5 2.5 0 0012.73 12.73M6.1 6.1C4.37 7.2 3 9 3 10C3 10 5.5 16 10 16C11.56 16 12.95 15.38 14.09 14.56M9 4.07C9.33 4.02 9.66 4 10 4C14.5 4 17 10 17 10C17 10 16.42 11.18 15.5 12.27" stroke="#A2AAAD" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </button>
          </div>
        </div>

        <!-- Mensajes de error -->
        <div *ngIf="messages && messages.length > 0" class="form-messages">
          <p *ngFor="let message of messages" class="form-message">{{ message }}</p>
        </div>

        <!-- ¿Olvidaste tu contraseña? -->
        <div class="forgot-password">
          <span class="forgot-icon" aria-hidden="true">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="8" cy="8" r="7.25" stroke="#36424A" stroke-width="0.75"/>
              <text x="8" y="12" text-anchor="middle" font-family="Inter, sans-serif" font-size="10" fill="#36424A">i</text>
            </svg>
          </span>
          <span class="forgot-text">
            ¿Olvidaste tu contraseña?
            <a href="#" class="forgot-link" (click)="goToForgotPassword($event)">Haz click aquí</a>
          </span>
        </div>

        <!-- Botón submit -->
        <app-spinner-button class="btn-submit-spinner"
          [label]="getButtonLabel()"
          [enabled]="submitEnabled()"
          [running]="running">
        </app-spinner-button>

      </form>

      <!-- Registro -->
      <div class="login-register">
        <span>¿Primera vez aquí? </span>
        <a href="#" class="register-link" (click)="goToRegister($event)">Regístrate</a>
      </div>

    </div>

    <!-- Ilustración decorativa abajo-derecha -->
    <img
      src="/resources/assets/images/prototype/person-woman.png"
      alt=""
      class="right-illustration"
      aria-hidden="true"
    />
  </div>

</div>
